import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import SearchBarContext from '../context';

const Suggestion = styled.span`
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  width: ${props => props.width}px;
  padding-right: ${props => (props.theme.isMobile ? 2 : 5)}px;

  & em {
    color: ${props => props.theme.bodyColor};
    font-style: normal;
  }

  & > strong {
    float: right;
    position: relative;
    top: 4px;
    margin-left: ${props => (props.theme.isMobile ? 2 : 5)}px;
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    width: ${props => (props.theme.isMobile ? 54 : 64)}px;
    height: 20px;
    background-color: ${props => props.theme.secondaryColor};
    font-size: 11px;
    line-height: 20px;
    border-radius: 2px;
    color: white;
  }
`;

const Type = styled.span`
  text-transform: capitalize;
  white-space: nowrap;
`;

// search bar width, minus 2 horizontal paddings, minus the width of `remove`
const getWidth = w => w - 20 * 2 - 28;

export default function SuggestionEntry({ highlight, type }) {
  const { state: { width } } = React.useContext(SearchBarContext);

  return (
    <React.Fragment>
      <Suggestion
        dangerouslySetInnerHTML={{ __html: highlight }}
        width={getWidth(width)}
      />
      <Type>{type}</Type>
    </React.Fragment>
  );
}

SuggestionEntry.propTypes = {
  highlight: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};
